<template lang="pug">

  b-modal(hide-footer='' hide-header-close= '' no-close-on-esc='' no-close-on-backdrop='' v-model="modalShow" :title= "this.title")
    p.my-4 {{this.texto}}
    vue-recaptcha( v-if="isPublic" ref='recaptcha' @verify="verify" :sitekey="this.sitekey")

    div.float-right
      button.btn.btn-primary.m-1(@click.prevent='close' :disabled="loading") Cerrar
      button.btn.btn-danger.m-1(@click.prevent='confirm' :disabled="disabledCaptcha") {{buttonActionName}}
</template>

<script>

import {VueRecaptcha} from "vue-recaptcha";
import constants from "../constants";

export default {
  name: "Modal",
  components: {
    VueRecaptcha
  },
  data () {
    return {
      active: false,
      disabledCaptcha: true,
      sitekey: null
    }
  },
  props: {
    title: null,
    texto: null,
    modalShow: {
      type: Boolean,
      default: false
    },
    buttonAction: {
      type: Boolean,
      default: true
    },
    buttonActionName: {
      type: String,
      default: 'Guardar'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
    disabledSave: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    isAuto: {
      type: Boolean,
      default: true
    },
    isPublic: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.sitekey= constants.SITEKEY
    if(this.isPublic == false)
      this.disabledCaptcha = false
  },
  methods: {
    confirm: function () {
      this.$emit('confirmed');
      if(this.isAuto) {
        this.active = false;
      }
    },
    close: function () {
      this.$emit('close');
      this.active = false;
      if(this.isPublic == true)
        this.disabledCaptcha = true;
    },
    open: function () {
      this.$emit('open');
      this.active = true;
    },
    verify (response){
      if(response != null)
        this.disabledCaptcha = false;
    }
  }
}
</script>

<style scoped>
.modal-large {
  width: 80vw;
}
.content {
  min-height: 60vh;
}
</style>
